module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "form-steps-outer"
  }, [_c('div', {
    attrs: {
      "id": "back-to-quote-request"
    }
  }, [_c('div', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": function($event) {
        return _vm.$emit('close-rates')
      }
    }
  }, [_vm._v("\n        Back "), _c('i', {
    staticClass: "fa fa-arrow-left"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "backer clearfix inverse"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Origin")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(this.request.origin || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(this.request.dest || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v("\n            " + _vm._s(this.request.firstName + this.request.lastName !== '' ? this.request.firstName + ' ' + this.request.lastName : 'None set') + "\n          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Booking Agent")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(this.request.booker || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Account")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(this.request.account || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Job Type")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(this.request.jobType || 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Weight (Net LBS)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(this.request.weightsAndVolume.weightLbs && this.request.weightsAndVolume.weightLbs.net ? _vm.numberFormat(this.request.weightsAndVolume.weightLbs.net) : 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Volume (Net CbFt)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(this.request.weightsAndVolume.cubicFt && this.request.weightsAndVolume.cubicFt.net ? _vm.numberFormat(this.request.weightsAndVolume.cubicFt.net) : 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Weight (Net KG)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(this.request.weightsAndVolume.weightKgs && this.request.weightsAndVolume.weightKgs.net ? _vm.numberFormat(this.request.weightsAndVolume.weightKgs.net) : 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Volume (Net CBM)")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(this.request.weightsAndVolume.cubicM && this.request.weightsAndVolume.cubicM.net ? _vm.numberFormat(this.request.weightsAndVolume.cubicM.net) : 'None set'))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-4 col-lg-3"
  }, [_c('div', {
    staticClass: "tag"
  }, [_c('div', {
    staticClass: "key-head"
  }, [_vm._v("Cheapest Route Cost")]), _vm._v(" "), _c('div', {
    staticClass: "val"
  }, [_vm._v(_vm._s(_vm.cheapest))])])])])]), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-pills nav-justified mai-nav-pills"
  }, [_c('li', {
    class: [_vm.pill === 'rates' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.pill = 'rates'
      }
    }
  }, [_c('a', [_vm._v("Rates Overview")])]), _vm._v(" "), _c('li', {
    class: [_vm.pill === 'analysis' ? 'active' : ''],
    on: {
      "click": function($event) {
        _vm.pill = 'analysis'
      }
    }
  }, [_c('a', [_vm._v("Rates Analysis")])])]), _vm._v(" "), _c('section', {
    staticClass: "clearfix",
    attrs: {
      "id": "rates"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.graphVisible && _vm.pill === 'rates'),
      expression: "!graphVisible && pill === 'rates'"
    }]
  }, [_c('div', {
    staticClass: "select-sort clearfix"
  }, [_c('div', {
    staticClass: "msg"
  }, [_vm._v("\n          " + _vm._s(_vm.orderedRates.length) + " quotes\n        ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sortBy),
      expression: "sortBy"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.sortBy = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "cheap"
    }
  }, [_vm._v("Cheapest first")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "exp"
    }
  }, [_vm._v("Most expensive first")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "quick"
    }
  }, [_vm._v("Quickest first")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "slow"
    }
  }, [_vm._v("Slowest first")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "high"
    }
  }, [_vm._v("Highest quality")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "low"
    }
  }, [_vm._v("Lowest quality")])])]), _vm._v(" "), _vm._l((_vm.orderedRates), function(rate, i) {
    return _c('rate', {
      key: rate.optionNumber,
      attrs: {
        "index": i,
        "rate": rate,
        "currency": _vm.response.responseCurrency,
        "reporting-currency": _vm.response.reportingCurrency,
        "getQuality": _vm.getQuality
      },
      on: {
        "chosen": _vm.chosen,
        "item-chosen": _vm.itemChosen,
        "show-network-graph": _vm.showGraph
      }
    })
  }), _vm._v(" "), (_vm.choiceMade && _vm.choice !== null) ? _c('quote-rate-break-down', {
    staticStyle: {
      "top": "-430px",
      "position": "absolute",
      "height": "800px"
    },
    attrs: {
      "rate": _vm.getRate(_vm.choice),
      "reportingCurrency": _vm.response.reportingCurrency,
      "fName": _vm.request.firstName,
      "lName": _vm.request.lastName,
      "pu-date": _vm.request.pickUpDate,
      "brand-grp": _vm.request.brandGroup,
      "request": _vm.fullRequest,
      "response": _vm.response,
      "job": _vm.job,
      "pref-with-notes": _vm.prefWithNotes
    },
    on: {
      "close": function($event) {
        _vm.choiceMade = false;
        _vm.choice = null
      },
      "dataChange": function (data) { return _vm.$emit('quoteDetailsUpdate', data); },
      "job-saved": _vm.jobSaved,
      "job-save-error": _vm.showError
    }
  }) : _vm._e(), _vm._v(" "), (_vm.itemChoiceMade && _vm.itemChoice !== null && _vm.itemChoiceIndex !== null) ? _c('quote-rate-item-break-down', {
    staticStyle: {
      "top": "-430px",
      "position": "absolute",
      "height": "800px"
    },
    attrs: {
      "rate": _vm.getRate(_vm.itemChoice),
      "itemIndex": _vm.itemChoiceIndex,
      "request": _vm.fullRequest,
      "response": _vm.response
    },
    on: {
      "close": function($event) {
        _vm.itemChoiceMade = false;
        _vm.itemChoice = null;
        _vm.itemChoiceIndex = null
      },
      "update-option": _vm.updateOption
    }
  }) : _vm._e()], 2), _vm._v(" "), (_vm.graphVisible && _vm.pill === 'rates') ? _c('div', [_c('network-graph', {
    attrs: {
      "graphData": _vm.graphData,
      "visible": _vm.graphVisible,
      "highlight": _vm.pathNumber
    },
    on: {
      "close-graph": function($event) {
        _vm.graphVisible = false
      }
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pill === 'analysis'),
      expression: "pill === 'analysis'"
    }]
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-stacked-bar', {
    attrs: {
      "showLegend": false,
      "chartData": _vm.stackedData,
      "categoryField": "Option Number"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-bar', {
    attrs: {
      "showLegend": false,
      "chartData": _vm.durationChartData,
      "valueField": "Duration",
      "categoryField": "Option Number"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-layered-bar', {
    attrs: {
      "cluster": false,
      "minHeight": 700,
      "showLegend": false,
      "chartData": _vm.layeredData,
      "categoryField": "Option Number"
    }
  })], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "panel panel-default mai-panel"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "panel-body clearfix",
    staticStyle: {
      "min-height": "380px"
    }
  }, [_c('simple-bar', {
    attrs: {
      "showLegend": false,
      "chartData": _vm.qualityChartData,
      "valueField": "Quality",
      "categoryField": "Option Number"
    }
  })], 1)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Route segment comparison (Option Number by Cost)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Route duration comparison (Option Number by Days)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Route overall comparison (Option Number by Rate in hundreds by Quality score out of 100 by Duration in days)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('i', {
    staticClass: "fa fa-bar-chart"
  }), _vm._v(" Route quality comparison (Option Number by score/100)")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0cec3f30"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/quote/components/QuoteRates.vue
// module id = 2088
// module chunks = 1